<template>
  <div>
    <ExpandableSettingsItem class="configurable-pages" :title="$t('message.CFG_PAGES')" use-transition-expand>
      <ConfigurablePagesList @pageClick="onPageClick" />
    </ExpandableSettingsItem>
  </div>
</template>

<script>
/**
 * Page to display all the configurable pages for this team
 */
import ExpandableSettingsItem from '@/components/expandable-settings-item.vue';
import ConfigurablePagesList from '@/components/configurable-pages-list.vue';

export default {

  name: 'ConfigurablePages',

  components: {
    ExpandableSettingsItem,
    ConfigurablePagesList,
  },

  data() {
    return {
      // Properties used by other components. See src/views/readme.md
      pageTitle: this.$t('message.CFG_PAGES'),
    };
  },

  methods: {
    onPageClick(page) {
      this.$router.push(`/configurable-page?pageId=${page.id}&editable=true`);
    },
  },
};
</script>

<style lang="scss">
.configurable-pages {
  overflow: auto;
}
</style>
